"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImageApiPath = exports.getImageCachePath = void 0;
var jssha_1 = __importDefault(require("jssha"));
var IMG_ENDPOINT = "/api/images/img";
// https://startup-academy-stage.s3.eu-central-1.amazonaws.com/imgcache/5c14861ecd894c6eccc5604658cc2401f8a82aaf.jpg
var getHash = function (string) {
    var sha = new jssha_1.default("SHA-1", "TEXT", { encoding: "UTF8" });
    sha.update(string);
    return sha.getHash("HEX");
};
var paramsToUrl = function (params) {
    return Object.entries(params)
        .map(function (e) { return (typeof e[1] === "undefined" ? "" : e.join("=")); })
        .join("&");
};
var getStringifyParams = function (params) {
    var paramsInString = JSON.stringify(params);
    // in backend, empty params are empty array
    return paramsInString === JSON.stringify({}) ? "[]" : paramsInString;
};
var getImageCachePath = function (imagePath, params, prefix, format) {
    var _a;
    if (params === void 0) { params = {}; }
    var hash = getHash(imagePath + getStringifyParams(__assign(__assign({}, params), { format: format })));
    return "".concat(prefix, "/").concat(hash, ".").concat(format || ((_a = imagePath === null || imagePath === void 0 ? void 0 : imagePath.split(".")) === null || _a === void 0 ? void 0 : _a.pop()));
};
exports.getImageCachePath = getImageCachePath;
var getImageApiPath = function (apiUrl, imagePath, params, format) {
    if (params === void 0) { params = {}; }
    return "".concat(apiUrl).concat(IMG_ENDPOINT, "/?").concat(paramsToUrl(__assign(__assign({}, params), { path: imagePath, format: format })));
};
exports.getImageApiPath = getImageApiPath;
